import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUserInvitation } from "../../../store/invitations";
import PropTypes from "prop-types";
import CreateTeamRandom from "../../../page/createTeamRandom";
import { getGroupError, setGroupErrorNull } from "../../../store/groups";
import CafesLoader from "../../hoc/cafesLoader";
import ModalShell from "./ModalShell";
import { useI18n } from "../../../i18n/LanguageContext";

const CreateRandomTeamModal = ({ onShowModal }) => {
  const invitation = useSelector(getCurrentUserInvitation());
  const groupError = useSelector(getGroupError());
  const dispatch = useDispatch();
  const { t } = useI18n();
  const closeRef = useRef(() => {});
  const requestClose = () => closeRef.current();

  const handleClose = () => {
    if (groupError !== null) {
      dispatch(setGroupErrorNull(null));
    }
    requestClose();
  };

  return (
    <CafesLoader>
      <ModalShell onClose={() => onShowModal()} closeRef={closeRef}>
        <div className="relative flex w-full min-w-0 flex-col rounded-lg border-0 bg-white shadow-lg outline-none">
          <div className="flex justify-center rounded-t border-b border-solid border-slate-200 bg-lime-100 px-4 py-4 sm:py-6">
            <h3 className="px-2 text-lg font-bold sm:text-xl">{t("team.title")}</h3>
          </div>
          {invitation !== undefined ? (
            <div className="flex justify-center p-4">
              <p className="px-4 text-center font-bold">{t("team.invited")}</p>
            </div>
          ) : (
            <div className="min-w-0 p-2 sm:p-4">
              {groupError === null ? (
                <CreateTeamRandom />
              ) : (
                <div className="flex flex-col px-2 sm:px-5">
                  <div className="break-words py-5">{groupError}</div>
                  {groupError === "GIRLS_NOT_FOUND" ||
                  groupError === "MANS_NOT_FOUND" ? (
                    <p>{t("team.tryLater")}</p>
                  ) : null}
                </div>
              )}
            </div>
          )}
          <div className="flex items-center justify-end rounded-b border-t border-solid border-slate-200 p-4 sm:p-6">
            <button
              className="btn-smooth rounded-md bg-slate-100 px-6 py-2 text-sm font-bold uppercase text-red-300 outline-none hover:bg-slate-200 hover:text-red-500"
              type="button"
              onClick={handleClose}
            >
              {t("common.close")}
            </button>
          </div>
        </div>
      </ModalShell>
    </CafesLoader>
  );
};

CreateRandomTeamModal.propTypes = {
  onShowModal: PropTypes.func,
};

export default CreateRandomTeamModal;
